module.exports = __webpack_public_path__ + "img/rbe-error-desktop.3008bcc.svg";